export const getHeatmapWindSpeed = (name, radius = 20) => {
  return {
    id: "wind-speed",
    type: "heatmap",
    config: {
      dataId: "wind-speed",
      label: "heatmap",
      color: [241, 92, 23],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer YlGnBu-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#ffffcc",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#2c7fb8",
            "#253494",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: name,
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: name,
        type: "real",
      },
      weightScale: "linear",
    },
  }
}

export const getHeatmapWindSpeedNorm = (name, radius = 25) => {
  return {
    id: "wind-speed",
    type: "heatmap",
    config: {
      dataId: "wind-speed",
      label: name,
      color: [241, 92, 23],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer YlGnBu-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#ffffcc",
            "#c7e9b4",
            "#7fcdbb",
            "#41b6c4",
            "#2c7fb8",
            "#253494",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      weightScale: "linear",
    },
  }
}